import { ButtonBase } from '@mui/material'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { STATUS_CODE, keywordScreen } from '~/constants'
import { route } from '~/routes/path'
import { resetStatePayment } from '~/views/OrderHistory/slices'
import {
  fetchInfoPayment,
  infoPaymentSelector,
  requestPayment,
} from '~/views/Payment/slices/paymentSlice'
import styles from './PopupReadyToPay.module.scss'

const cx = classNames.bind(styles)

const PopupReadyToPay = ({ onClosePopup }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { data, loading, error, request } = useSelector(infoPaymentSelector)
  const navigate = useNavigate()

  const onConfirmPayment = () => {
    dispatch(requestPayment())
  }

  useEffect(() => {
    dispatch(fetchInfoPayment())

    // if (errorData?.message === 'NEED_TO_RESCAN_QR') {
    //   localStorage.removeItem(STORAGE_KEYS.servingToken)
    //   navigate(path.rescanQR)
    // }

    return () => {
      dispatch(resetStatePayment())
    }
    // , errorData, navigate
  }, [dispatch])

  // Nếu request thành công => chuyển đến màn success.
  useEffect(() => {
    if (request) {
      const url = `${route.confirmedPaymentTablet}/${keywordScreen.payment}`
      navigate(url)
    }
  }, [request, navigate])

  const renderError = useCallback(() => {
    if (error && error?.status === STATUS_CODE.NOT_FOUND) return t('titles.order_empty')
  }, [error, t])

  return (
    <div className={cx('wrapper')}>
      <span className={cx('header')}>{t('titles.popup_pay')}</span>
      <div className={cx('cta_wrapper')}>
        <span className={cx('txt_error')}>{renderError()}</span>
        <div className={cx('btn_wrapper')}>
          <ButtonBase className={cx('btn', 'txt_btn')} onClick={onConfirmPayment} disabled={error}>
            {t('titles.ask_for_bill')}
          </ButtonBase>
          <span className={cx('txt_decription')}>{t('titles.ask_for_bill_decription')}</span>
        </div>
        <ButtonBase className={cx('txt_not_yet')} onClick={onClosePopup}>
          {t('titles.not_yet')}
        </ButtonBase>
      </div>
    </div>
  )
}

export default React.memo(PopupReadyToPay)

PopupReadyToPay.propTypes = {
  onClosePopup: PropTypes.func,
}
